export const getSingleLoadingState = (...loadingStates: boolean[]) => {
  return loadingStates.some(loading => loading === true)
};
